import CloseIcon from "@mui/icons-material/Close";

interface RedemptionFilterChipProps {
  label: string;
  onRemove: () => void;
}

/**
 * An active-filter chip in the recipient feed — the filter's label + a round
 * remove (×) button. Rendered by RedemptionCollection above the grid, one per
 * active category / cause / favorites filter.
 */
export default function RedemptionFilterChip({ label, onRemove }: RedemptionFilterChipProps) {
  return (
    <span className="inline-flex items-center gap-1 rounded-full border border-dark-dust bg-clear-dust py-1.25 pl-3 pr-2.5 font-lato text-[12px] font-semibold tracking-[0.3px] text-rodeo-black">
      {label}
      <button
        type="button"
        onClick={onRemove}
        title="Remove filter"
        aria-label={`Remove ${label} filter`}
        className="relative flex h-4.5 w-4.5 cursor-pointer items-center justify-center rounded-full text-dark-dust transition-colors hover:bg-dark-dust hover:text-white max-md:before:absolute max-md:before:-inset-3.25 max-md:before:content-['']"
      >
        <CloseIcon sx={{ fontSize: 14 }} />
      </button>
    </span>
  );
}
